import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { DaysForm } from '@modules/hr-templates/days/DaysForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const daysUrl = '/metropolis/api/hr/workplan/calendar/day';
export const daysLabel = 'Personalistika - denní šablony';
export const daysPath = '/hr/templates/days';
export const daysGridName = 'DaysGrid';
export const DaysGrid = compose(
  withRouter,
  setDisplayName(daysGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: daysLabel }]),
  withColumns(Agenda.DAYS),
  withProps(({ columns }) => ({
    name: daysGridName,
    url: daysUrl,
    Form: DaysForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.DAYS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/days/DaysGrid.tsx